



















import Vue from 'vue';
import InputWrapper from '../bases/InputWrapper/InputWrapper.vue';
import BaseFormElem from '../bases/BaseFormElem.vue';
import Button from '../../buttons/Button/Button.vue';

export default Vue.extend({
  name: 'FileInput',
  extends: BaseFormElem,
  components: {InputWrapper, Button},
  props: {
    placeholder: {
      type: String,
      default: 'Upload your file',
    },
    disabled: Boolean,
    value: {}, // to ignore value from insert to input
  },
  data: () => ({
    fileName: '',
  }),
  methods: {
    handleFileChange(files: FileList) {
      if (files && files.length > 0) {
        this.$emit('input', files[0]);
        this.fileName = files[0].name;
      } else {
        // Cancelling the dialogue clears the form element in Chrome,
        // so also clear the component state.
        this.$emit('input', null);
        this.fileName = '';
      }
    },
    selectFile() {
      const inputElem = this.$refs.inputElem as HTMLInputElement;
      inputElem.click();
    },
  },
});
